const PLAY_STORE_BASE =
  "https://play.google.com/store/apps/details?id=com.schooglink.curriculum.pathcharya";

export function buildPlayStoreUrl({
  source = "website",
  medium = "pathyacharya_page",
  campaign = "hindi_landing",
  term,
} = {}) {
  const params = new URLSearchParams({
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  });
  if (term) params.set("utm_term", term);
  return `${PLAY_STORE_BASE}&${params.toString()}`;
}

export const PLAY_STORE_BADGE_HI =
  "https://play.google.com/intl/en_us/badges/static/images/badges/hi_badge_web_generic.png";

export function readUtmFromLocation() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  const out = {};
  ["source", "medium", "campaign", "term", "content"].forEach((k) => {
    const v = p.get(`utm_${k}`);
    if (v) out[k] = v;
  });
  return out;
}
